// import { sentryGlobalFunctionMiddleware } from "@sentry/tanstackstart-react";
import { createCsrfMiddleware, createStart } from "@tanstack/react-start";

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => {
  return {
    serializationAdapters: [],
    functionMiddleware: [
      // sentryGlobalFunctionMiddleware as unknown as AnyFunctionMiddleware,
    ],
    requestMiddleware: [csrfMiddleware],
  };
});
